import { createSlice } from "@reduxjs/toolkit";
import VwGnlKurumgrupDTO from "src/models/GenelTanimlar/VwGnlKurumgrupDTO";
import VwGnlKurumTarifeDTO from "src/models/Settings/Generals/VwGnlKurumTarifeDTO";
import VwKurumDTO from "src/models/Settings/Generals/VwKurumDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";


interface IKurumGrupTanim {
    kurumGrupDialog: boolean,
    activeRow: VwGnlKurumgrupDTO,
    kurumGrupFormDialog: boolean,

};

export const KurumGrupTanimSlice = createSlice<IKurumGrupTanim, MapReducerPayloads<IKurumGrupTanim, {
    setKurumGrupDialog: boolean,
    setActiveRow: VwGnlKurumgrupDTO,
    setKurumGrupFormDialog: boolean

}>>({
    name: "kurumGrupTanim",
    initialState: {
        kurumGrupDialog: false,
        activeRow: new VwGnlKurumgrupDTO(),
        kurumGrupFormDialog: false,
    },
    reducers: {
        setKurumGrupDialog: (state, action) => {
            state.kurumGrupDialog = action.payload
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },
        setKurumGrupFormDialog: (state, action) => {
            state.kurumGrupFormDialog = action.payload
        },
    }
});